import { date, object, ref, string } from 'yup';

import { DATE_IN_PAST, END_DATE_BEFORE_START_DATE, REQUIRED_FIELD } from '@/config/text.const';

export const validationSchema = object().shape({

  dateFrom: date()
    .typeError(REQUIRED_FIELD)
    .nullable()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), DATE_IN_PAST),

  dateTo: date()
    .typeError(REQUIRED_FIELD)
    .optional()
    .nullable()
    .min(new Date(new Date().setHours(0, 0, 0, 0)), DATE_IN_PAST)
    .min(ref('dateFrom'), END_DATE_BEFORE_START_DATE),

  searchString: string()
    .optional()
    .nullable(),

  contractID: string()
    .optional()
    .nullable(),
  customerID: string()
    .optional()
    .nullable(),
});